export default __webpack_public_path__ + "static/media/Ellipse 2.645438a6.svg";